import { GraphQLObjectType, GraphQLString, GraphQLBoolean, GraphQLFloat } from 'graphql';

const cardQuestionOptionType = new GraphQLObjectType({
  name: 'CardQuestionOptionType',
  fields: () => ({
    text: {
      type: GraphQLString,
      resolve: root => root.optionText
    },
    correct: {
      type: GraphQLBoolean,
      resolve: root => root.optionEvaluation
    },
    relativeScore: {
      type: GraphQLFloat,
      resolve: root => root.optionRelativeScore || 0.0
    }
  })
});

window[cardQuestionOptionType.name + 'GQLType'] = cardQuestionOptionType;

export default cardQuestionOptionType;
